(function(angular, schoolwork12) {
    'use strict';
    schoolwork12.app.bulkImport = {
        name: 'schoolwork12.bulkImport',
        controllers: {
        	bulkImport: 'bulkImportCntrl'
        },
        services: {
        	bulkImportSvc: 'bulkImportSvc',
        },
        routes: {
        	bulkImport: '/bulk-import'
        },
        templates: {
        	bulkImport: 'bulkImport/html/bulkImport.html'
        },
        endpoints: {
        	bulkAttAdjustment: schoolwork12.app.endpoint.concat('/bulk/attAdjustment'),
        	bulkAddRequirement: schoolwork12.app.endpoint.concat('/bulk/addRequirements'),
            bulkGradPlan: schoolwork12.app.endpoint.concat('/bulk/gradPlanDetails'), 
            bulkCourseCatalog: schoolwork12.app.endpoint.concat('/bulk/courseUpdate'),
            bulkSchoolHoliday: schoolwork12.app.endpoint.concat('/bulk/holiday'),
            bulkSchoolDate: schoolwork12.app.endpoint.concat('/bulk/schoolDates'),
            bulkStudentCreate: schoolwork12.app.endpoint.concat('/bulk/students')
        },
        errorMessages: {
        	selectFileRequired: "A file should be selected.",
        	failPrevalidation: 'Error: Download the Error Log for more details.'
        },
        successMessages:{
        	attAdjustmentImportSuccesMsg: "Your attendance adjustment details have been imported! Please check the Submission log for status of the upload.",
        	addRequirementsImportSuccesMsg: "Your additional requirements details have been imported! Please check the Submission log for status of the upload.",
            gradPlanImportSuccesMsg: "Your graduation plan details have been imported! Please check the Submission log for status of the upload.",
            courseCatalogImportSuccesMsg: "Your course catalog details have been imported! Please check the Submission log for status of the upload.",
            schoolHolidayImportSuccesMsg: "Your school holiday details have been imported! Please check the Submission log for status of the upload.",
            schoolDatesImportSuccesMsg: "Your school dates details have been imported! Please check the Submission log for status of the upload.",
            studentCreateImportSuccesMsg: "Your student create/update details have been imported! Please check the Submission log for status of the upload."
        }

    };
    angular.module(schoolwork12.app.bulkImport.name, []);

}(angular, schoolwork12));
